// Date 2020-12-02 16:57:55

import emEntityListView from "@/components/em/EmEntity/ListView";
import emEntityEditView from "@/components/em/EmEntity/EditView";
import emLevelTreeListView from "@/components/em/EmLevelTree/ListView";

import emAclRoleEdit from "@/views/em/admin/EmAclRoleEdit.vue";
import emAclRoleList from "@/views/em/admin/EmAclRoleList.vue";
import emAclUserList from "@/views/em/admin/EmAclUserList.vue";
import emAclUserEdit from "@/views/em/admin/EmAclUserEdit.vue";
import emAdmSysLogEdit from "@/views/em/admin/EmAdmSysLogEdit.vue";
import emAdmSysLogList from "@/views/em/admin/EmAdmSysLogList.vue";
import emAdmSysOperateLogEdit from "@/views/em/admin/EmAdmSysOperateLogEdit.vue";
import emAdmSysOperateLogList from "@/views/em/admin/EmAdmSysOperateLogList.vue";
import emAdmFactoryModelEafmEdit from "@/views/em/admin/EmAdmFactoryModelEafmEdit.vue";
import emAdmFactoryModelEafmList from "@/views/em/admin/EmAdmFactoryModelEafmList.vue";
import imfMstLocationList from "@/views/em/admin/ImfMstLocationList";
import imfMstLocationEdit from "@/views/em/admin/ImfMstLocationEdit";
import imfMstShiftTeamEdit from "@/views/em/admin/ImfMstShiftTeamEdit";
import imfMstShiftTeamList from "@/views/em/admin/ImfMstShiftTeamList";
import emAttachmentList from "@/views/em/admin/EmAttachmentList";
import emAttachmentEdit from "@/views/em/admin/EmAttachmentEdit";
import emChangePassword from "@/views/em/admin/EmChangePassword";
import emDictTypeList from "@/views/em/admin/EmDictTypeList.vue";
import emDictTypeEdit from "@/views/em/admin/EmDictTypeEdit.vue";
import emEmAdmUserGroupList from "@/views/em/admin/EmEmAdmUserGroupList.vue";
import emEmAdmUserGroupEdit from "@/views/em/admin/EmEmAdmUserGroupEdit.vue";
import emMenuList from "@/views/em/admin/EmMenuList.vue";
import businessModuleList from "@/views/em/admin/BusinessModuleList";
import businessModuleEdit from "@/views/em/admin/BusinessModuleEdit";

const metaObject = {requiresAuth: true, roles: ['mmf']};

export default [
//公用组件注册
    {
        path: "/em/admin/emMenu/list",
        name: "emMenuList",
        component: emMenuList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/admin/emMenu/edit",
        name: "emMenuEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/admin/emCssIcon/list",
        name: "emCssIconList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/admin/emCssIcon/edit",
        name: "emCssIconEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/admin/emMenuType/list",
        name: "emMenuTypeList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/admin/emMenuType/edit",
        name: "emMenuTypeEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/admin/emViewCrudState/list",
        name: "emViewCrudStateList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/admin/emViewCrudState/edit",
        name: "emViewCrudStateEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/admin/emAclDept/list",
        name: "emAclDeptList",
        component: emLevelTreeListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/admin/emAclDept/edit",
        name: "emAclDeptEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/admin/emAclRoleAcl/list",
        name: "emAclRoleAclList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/admin/emAclRoleAcl/edit",
        name: "emAclRoleAclEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/admin/emAclRoleUser/list",
        name: "emAclRoleUserList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/admin/emAclRoleUser/edit",
        name: "emAclRoleUserEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/admin/emAdmSysParam/list",
        name: "emAdmSysParamList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/admin/emAdmSysParam/edit",
        name: "emAdmSysParamEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/admin/emAdmNotification/list",
        name: "emAdmNotificationList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/admin/emAdmNotification/edit",
        name: "emAdmNotificationEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/admin/emAclLocationType/list",
        name: "emAclLocationTypeList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/admin/emAclLocationType/edit",
        name: "emAclLocationTypeEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/admin/emAclLocation/list",
        name: "emAclLocationList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/admin/emAclLocation/edit",
        name: "emAclLocationEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/admin/emAdmFactoryModelTypeEafmt/list",
        name: "emAdmFactoryModelTypeEafmtList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/admin/emAdmFactoryModelTypeEafmt/edit",
        name: "emAdmFactoryModelTypeEafmtEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/admin/emAdmRoleTag/list",
        name: "emAdmRoleTagList",
        component: emEntityListView,
        props: (route) => ({
            prop_inline: route.query.inline,
            prop_import: route.query.import,
            prop_export: route.query.export
        }),
        meta: metaObject
    },
    {
        path: "/em/admin/emAdmRoleTag/edit",
        name: "emAdmRoleTagEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/admin/imfMstLocationShiftRule/list",
        name: "imfMstLocationShiftRuleList",
        component: emEntityListView,
        props: (route) => ({
            prop_inline: route.query.inline,
            prop_import: route.query.import,
            prop_export: route.query.export
        }),
        meta: metaObject
    },
    {
        path: "/em/admin/imfMstLocationShiftRule/edit",
        name: "imfMstLocationShiftRuleEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/admin/imfMstShift/list",
        name: "imfMstShiftList",
        component: emEntityListView,
        props: (route) => ({
            prop_inline: route.query.inline,
            prop_import: route.query.import,
            prop_export: route.query.export
        }),
        meta: metaObject
    },
    {
        path: "/em/admin/imfMstShift/edit",
        name: "imfMstShiftEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/admin/imfMstShiftRule/list",
        name: "imfMstShiftRuleList",
        component: emEntityListView,
        props: (route) => ({
            prop_inline: route.query.inline,
            prop_import: route.query.import,
            prop_export: route.query.export
        }),
        meta: metaObject
    },
    {
        path: "/em/admin/imfMstShiftRule/edit",
        name: "imfMstShiftRuleEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/admin/imfMstShiftTime/list",
        name: "imfMstShiftTimeList",
        component: emEntityListView,
        props: (route) => ({
            prop_inline: route.query.inline,
            prop_import: route.query.import,
            prop_export: route.query.export
        }),
        meta: metaObject
    },
    {
        path: "/em/admin/imfMstShiftTime/edit",
        name: "imfMstShiftTimeEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/admin/imfMstCalendar/list",
        name: "imfMstCalendarList",
        component: emEntityListView,
        props: (route) => ({
            prop_inline: route.query.inline,
            prop_import: route.query.import,
            prop_export: route.query.export
        }),
        meta: metaObject
    },
    {
        path: "/em/admin/imfMstCalendar/edit",
        name: "imfMstCalendarEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/admin/imfMstShiftTeamUser/list",
        name: "imfMstShiftTeamUserList",
        component: emEntityListView,
        props: (route) => ({
            prop_inline: route.query.inline,
            prop_import: route.query.import,
            prop_export: route.query.export
        }),
        meta: metaObject
    },
    {
        path: "/em/admin/imfMstShiftTeamUser/edit",
        name: "imfMstShiftTeamUserEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/admin/imfMstLocationTagLoct/list",
        name: "imfMstLocationTagLoctList",
        component: emEntityListView,
        props: (route) => ({
            prop_inline: route.query.inline,
            prop_import: route.query.import,
            prop_export: route.query.export
        }),
        meta: metaObject
    },
    {
        path: "/em/admin/imfMstLocationTagLoct/edit",
        name: "imfMstLocationTagLoctEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/admin/emAdmUserTag/list",
        name: "emAdmUserTagList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline, prop_import: '1', prop_export: '1'}),
        meta: metaObject
    },
    {
        path: "/em/admin/emAdmUserTag/edit",
        name: "emAdmUserTagEdit",
        component: emEntityEditView,
        meta: metaObject
    },
//自定义页面注册
    {
        path: "/em/admin/emAclRoleEdit",
        name: "emAclRoleEdit",
        component: emAclRoleEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/admin/emAclRoleList",
        name: "emAclRoleList",
        component: emAclRoleList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/admin/emAclUserList",
        name: "emAclUserList",
        component: emAclUserList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/admin/emAclUserEdit",
        name: "emAclUserEdit",
        component: emAclUserEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/admin/emAdmSysLogEdit",
        name: "emAdmSysLogEdit",
        component: emAdmSysLogEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/admin/emAdmSysLogList",
        name: "emAdmSysLogList",
        component: emAdmSysLogList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/admin/emAdmSysOperateLogEdit",
        name: "emAdmSysOperateLogEdit",
        component: emAdmSysOperateLogEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/admin/emAdmSysOperateLogList",
        name: "emAdmSysOperateLogList",
        component: emAdmSysOperateLogList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/admin/emAdmFactoryModelEafmEdit",
        name: "emAdmFactoryModelEafmEdit",
        component: emAdmFactoryModelEafmEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/admin/emAdmFactoryModelEafmList",
        name: "emAdmFactoryModelEafmList",
        component: emAdmFactoryModelEafmList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/admin/imfMstLocationList",
        name: "imfMstLocationList",
        component: imfMstLocationList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/admin/imfMstLocationEdit",
        name: "imfMstLocationEdit",
        component: imfMstLocationEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/admin/imfMstShiftTeamEdit",
        name: "imfMstShiftTeamEdit",
        component: imfMstShiftTeamEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/admin/imfMstShiftTeamList",
        name: "imfMstShiftTeamList",
        component: imfMstShiftTeamList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/admin/emAdmGroup/list",
        name: "emAdmGroupList",
        component: emEntityListView,
        props: (route) => ({
            prop_inline: route.query.inline,
            prop_import: route.query.import,
            prop_export: route.query.export
        }),
        meta: metaObject
    },
    {
        path: "/em/admin/emAdmGroup/edit",
        name: "emAdmGroupEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/admin/emAdmOrganization/list",
        name: "emAdmOrganizationList",
        component: emEntityListView,
        props: (route) => ({
            prop_inline: route.query.inline,
            prop_import: route.query.import,
            prop_export: route.query.export
        }),
        meta: metaObject
    },
    {
        path: "/em/admin/emAdmOrganization/edit",
        name: "emAdmOrganizationEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/admin/emAclUserType/list",
        name: "emAclUserTypeList",
        component: emEntityListView,
        props: (route) => ({
            prop_inline: route.query.inline,
            prop_import: route.query.import,
            prop_export: route.query.export
        }),
        meta: metaObject
    },
    {
        path: "/em/admin/emAclUserType/edit",
        name: "emAclUserTypeEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/admin/emAclUserJob/list",
        name: "emAclUserJobList",
        component: emEntityListView,
        props: (route) => ({
            prop_inline: route.query.inline,
            prop_import: route.query.import,
            prop_export: route.query.export
        }),
        meta: metaObject
    },
    {
        path: "/em/admin/emAclUserJob/edit",
        name: "emAclUserJobEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/admin/emAttachmentList",
        name: "emAttachmentList",
        component: emAttachmentList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/admin/emAttachmentEdit",
        name: "emAttachmentEdit",
        component: emAttachmentEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/admin/changePassword",
        name: "emChangePassword",
        component: emChangePassword,
        meta: metaObject
    },
    {
        path: "/em/admin/emDictTypeList",
        name: "emDictTypeList",
        component: emDictTypeList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/admin/emDictTypeEdit",
        name: "emDictTypeEdit",
        component: emDictTypeEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/admin/emEmAdmUserGroupList",
        name: "emEmAdmUserGroupList",
        component: emEmAdmUserGroupList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/admin/emEmAdmUserGroupEdit",
        name: "emEmAdmUserGroupEdit",
        component: emEmAdmUserGroupEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/admin/businessModuleList",
        name: "businessModuleList",
        component: businessModuleList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/admin/businessModuleEdit",
        name: "businessModuleEdit",
        component: businessModuleEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    }
]
